import React from 'react';
import { browserHistory } from 'react-router';
import GlobalVar from '../../../shared/globalVar/GlobalVar';
import clientService from '../../../../utils/services/client';
import * as globalMessageActions from '../../../../actions/globalMessageActions';
import './_Configuration.scss';

/**
 * This component gonna handle with client Global Var configurations
 */
export default class ClientConfiguration extends React.Component {

  /**
   * Class constructor
   * @param {*} props 
   */
  constructor(props){
    super(props);

    this.state ={
      clientId: this.props.params.clientId
    };

  }

  /**
   * Component will mount
   */
  componentWillMount() {
    
    let that = this;

    if (this.state.clientId) {

      // get client data
      clientService.getClient(this.state.clientId)
        .then((result) => {

          this.setState({client : result.data});
        })
        .catch((err) => {
          that.props.dispatch(globalMessageActions.showMessage(
            {
              type: 'error',
              message: err.response.data.message,
              timeout: 10000
            }
          ));
        });
    }    
  }

  /**
   * Main render
   */
  render(){

    const sections = [
      { context: 'POST_REWARD',            title: 'Post Reward',       subtitle: 'Configure settings for post reward actions.',                    icon: 'fa-gift'      },
      { context: 'LANDING_PAGE',           title: 'Landing Page',      subtitle: 'Configure access controls for landing pages.',                   icon: 'fa-home'      },
      { context: 'CLIENT.ANTI_FRAUD',      title: 'Anti Fraud',        subtitle: 'Manage anti-fraud rules and blacklists.',                        icon: 'fa-shield'    },
      { context: 'CLIENT.TRACKING',        title: 'Tracking',          subtitle: 'Configure click and event tracking deduplication.',              icon: 'fa-bar-chart' },
      { context: 'CLIENT.SECURITY',        title: 'Security',          subtitle: 'Configure security and data retention policies.',                icon: 'fa-lock'      },
      { context: 'CLIENT.INFRA',           title: 'Infrastructure',    subtitle: 'Configure infrastructure and email queue settings.',             icon: 'fa-server'    },
      { context: 'CLIENT.USER_SEGMENTATION', title: 'User Segmentation', subtitle: 'Configure user profile capture and segmentation settings.',   icon: 'fa-users'     },
    ];

    return(
      <div className="client-config-page">

        <div className="client-config-header">
          <button className="client-config-back-btn" onClick={browserHistory.goBack}>
            <i className="fa fa-arrow-left"></i> Back
          </button>
          <div className="client-config-breadcrumb">
            <span>ADMIN</span>
            <i className="fa fa-angle-right"></i>
            <span>GLOBAL VARIABLES</span>
          </div>
          <h1 className="client-config-title">
            {this.state.client ? this.state.client.name : ''} — Global Variables &amp; Settings
          </h1>
        </div>

        {sections.map(section => (
          <div key={section.context} className="gv-section">
            <div className="gv-section-header">
              <div className="gv-section-icon">
                <i className={`fa fa-fw ${section.icon}`}></i>
              </div>
              <div className="gv-section-header-text">
                <div className="gv-section-title">{section.title}</div>
                <div className="gv-section-subtitle">{section.subtitle}</div>
              </div>
            </div>
            <GlobalVar context={section.context} objectId={this.state.clientId} />
          </div>
        ))}


      </div>
    );
  }
}